import Vue from 'vue';
import App from './App.vue';
import store from './store';
import { BaseMixins, Helpers } from '@discoveryeducation/core';
import Fragment from 'vue-fragment';
import '@discoveryeducation/theme/src/main.styl';
import './styles/main.styl';
import VueCompositionAPI from '@vue/composition-api';
import VueSvgInlinePlugin from 'vue-svg-inline-plugin';

import 'vue-svg-inline-plugin/src/polyfills';

Vue.config.productionTip = false;

const i18n = Helpers.i18n;

Vue.mixin(BaseMixins.activityManagerMixin);
Vue.use(Fragment.Plugin);
Vue.use(VueCompositionAPI);
Vue.use(VueSvgInlinePlugin);

new Vue({
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
